const { differenceInDays } = require("date-fns");

/**
 * Retrieves content from a specified page using a Google Apps Script API.
 * @param {string} [asthaan='guru-har-rai-sahib-west-bromwich'] - The name of the page to retrieve content from.
 * @returns {Promise<any>} - A promise that resolves to the retrieved content.
 */
function getJsonContent(asthaan = "guru-har-rai-sahib-west-bromwich") {
  let url = `/backend/${asthaan}.json`;
  // if (pageName === "events") {
  //   url = `https://script.google.com/macros/s/AKfycbzCMlzcUE_yVGi-4qjIkLg0gxqVyI_EsVnERlypezRt5iuuzXbZ7_pqILdIPql5rEMB/exec/exec?page=${pageName}`;
  // }
  if (process.env?.NODE_ENV === "development") {
    url = "/assets/testEvents.json";
  }

  return fetch(url)
    .then((response) => response.json())
    .then((raw) => {
      // only return events that are today or in the future
      let out = {};
      out.events = raw.data.filter((event) => {
        const eventDate = new Date(event.date);
        const today = new Date();
        // console.log({ eventDate, today, diff: differenceInDays(eventDate, today)});
        return (
          !Number.isNaN(eventDate) && differenceInDays(eventDate, today) >= 0
        );
      });
      out.lastUpdated = new Date(raw?._metadata?.generatedAt).toLocaleString();
      return out;
    })
    // sort events by date
    .then((raw) => {
      let out = Object.assign({}, raw);
      out.events = raw.events.sort(
        (a, b) => new Date(a.date) - new Date(b.date)
      );
      return out;
    })
    .catch((error) => {
      if (error.name === "TimeoutError") {
        console.error("timeout error", error);
      }
      console.error("Error:", error);
    });
}

module.exports = { getJsonContent };
